import { IsVarEmpty } from './GlobalFunctions'

/**
 * A set of Array utilities.
 */
export class ArrayUtils {
    public static isEmpty<T>(arr?: T[]): arr is undefined {
        return IsVarEmpty(arr) || arr.length === 0
    }

    /**
     * Sort the array alphabetically by a string field.
     *
     * @param arr - Array to sort.
     * @param fieldAccessor - Function to retrieve the field.
     *
     * @returns - Sorted Array.
     */
    public static sortAlphabeticalByField<T>(arr: T[], fieldAccessor: (obj: T) => string): T[] {
        return arr.sort((a: T, b: T): number => fieldAccessor(a).localeCompare(fieldAccessor(b)))
    }

    public static createObjectFromArray = <T>(entries: [string, T][]): { [key: string]: T } =>
        entries.reduce(
            (accum, [key, value]) => {
                accum[key] = value

                return accum
            },
            {} as { [key: string]: T }
        )

    public static onlyUnique = <T>(value: T, index: number, self: T[]): boolean => self.indexOf(value) === index

    public static removeDuplicates = <T>(arr: T[]): T[] => arr.filter(ArrayUtils.onlyUnique)

    public static includesAll = <T>(arr?: T[], values?: T[]): boolean => {
        if (!arr || !values) {
            return false
        }

        return values.every((value: T) => arr.includes(value))
    }

    public static includesAny = <T>(arr?: T[], values?: T[]): boolean => {
        if (!arr || !values) {
            return false
        }

        return values.some((value: T) => arr.includes(value))
    }

    public static sortAlphabetically = <T extends string>(arr: T[]): T[] =>
        [...arr].sort((a: T, b: T): number => a.toString().localeCompare(b.toString()))

    public static removeFromArray = <T>(arr: T[], value: T): T[] => arr.filter((item: T) => item !== value)

    public static removeIndexFromArray = <T>(arr: T[], index: number): T[] => arr.filter((_, i: number) => i !== index)
}
